var _g, _g2, _g3, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M5.381 9.947a1.532 1.532 0 0 0 0-3.015 1.532 1.532 0 0 0 0 3.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M2.7 10.857a3.415 3.415 0 0 0 2.681.987 3.414 3.414 0 0 0 3.6-2.651L10.843.96l9.02 9.02-9.02 9.02L2.7 10.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M8.526.707V0l.483.483a1.72 1.72 0 0 0-.483.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M9.727.438l.476.475a1.7 1.7 0 0 0-.549.165l.073-.64z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.517 11.854a3.414 3.414 0 0 0 3.465-2.659L10.843.963l-.082-.019a1.564 1.564 0 0 0-1.107.137l-.88 7.747a3.414 3.414 0 0 1-3.257 3.026zM5.247 6.916a1.532 1.532 0 0 0 0 3.052c.045-.004.09-.01.135-.018a1.532 1.532 0 0 1 0-3.016 1.544 1.544 0 0 0-.135-.018zM5.517 5.03c.389-.016.754.03 1.127.144v.094a3.346 3.346 0 0 0-1.127-.239z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.526 8.44a3.414 3.414 0 0 1-3.28 3.411 3.414 3.414 0 0 0 3.528-3.026L9.727.438c-.451-.05-.815.013-1.201.268V8.44zM5.247 9.967a1.532 1.532 0 0 1 0-3.051 1.532 1.532 0 1 0 0 3.051zM5.247 5.028c.502.02.948.135 1.397.36v-.12a3.312 3.312 0 0 0-1.397-.24z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.526 0c-.575 0-1.043.204-1.412.654-.379.464-.47.934-.47 1.507v3.228A3.414 3.414 0 1 0 8.526 8.44V0zM5.112 9.972a1.532 1.532 0 1 1 0-3.063 1.532 1.532 0 0 1 0 3.063z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M6.644 8.442V5.39a3.305 3.305 0 0 0-1.422-.36v1.884a1.532 1.532 0 0 1 1.422 1.528z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.567 14.954c.09-.16.213-.287.37-.382a.977.977 0 0 1 .516-.143c.171 0 .336.04.494.119.158.079.289.194.392.344a.96.96 0 0 1 .163.53c.003.086-.003.169-.016.25H2.995c.024.098.077.177.159.234a.506.506 0 0 0 .3.086.54.54 0 0 0 .202-.032c.052-.021.1-.05.143-.084l.623.004a1.054 1.054 0 0 1-.953.623 1.032 1.032 0 0 1-1.037-1.033c0-.185.045-.357.135-.516zm1.376.3a.508.508 0 0 0-.19-.228.504.504 0 0 0-.284-.086.492.492 0 0 0-.474.313h.948zM4.86 16.47v-3.189h.522v3.19H4.86zM5.93 14.158a.303.303 0 0 1-.09-.223c0-.085.03-.159.09-.219.061-.06.135-.09.224-.09.086 0 .159.03.219.09s.09.134.09.22c0 .088-.03.162-.09.222a.298.298 0 0 1-.22.09.303.303 0 0 1-.222-.09zm-.037.304h.522v2.009h-.522v-2.01zM6.72 14.461h.547l.458 1.322.462-1.322h.547l-.748 2.01h-.522l-.744-2.01zM9.368 16.364a1.042 1.042 0 0 1-.518-.898 1.042 1.042 0 0 1 1.037-1.037 1.027 1.027 0 0 1 .894.516c.092.16.138.334.138.521v1.005h-.522v-.213c-.03.067-.094.124-.193.173a.716.716 0 0 1-.318.072c-.187 0-.36-.046-.518-.139zm.888-.522a.521.521 0 0 0 .145-.376.521.521 0 0 0-.145-.376.485.485 0 0 0-.365-.15.513.513 0 0 0-.518.526.513.513 0 0 0 .518.527c.147 0 .269-.05.365-.151zM1.678 13.354c-.131.107-.13.229-.13.376v.832a1.038 1.038 0 1 0 .527.903v-2.192c-.14 0-.27-.024-.397.08zm-.64 2.63a.518.518 0 1 1 0-1.036.518.518 0 0 1 0 1.035z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.786,
    x2: 9.169,
    y1: 4.727,
    y2: 9.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2.226,
    x2: 11.449,
    y1: 1.399,
    y2: 12.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 7.737,
    x2: 10.9,
    y1: -1.05,
    y2: 2.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 9.122,
    x2: 11.569,
    y1: -0.108,
    y2: 2.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 7.532,
    x2: 5.529,
    y1: 6.42,
    y2: 6.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivaIcon);
export default __webpack_public_path__ + "static/media/deliva_icon.bface06f5304a9827172feed38c9a925.svg";
export { ForwardRef as ReactComponent };